<template>
  <div>
    <v-file-input v-model="computedFile" label="Select file"></v-file-input>
    <v-alert v-if="Boolean(error)" type="error" outlined>{{ error }}</v-alert>
    <v-btn text x-small outlined color="primary" @click="downloadTemplate">
      <v-icon class="mr-2" small>mdi-download</v-icon>get template
    </v-btn>
    <v-switch v-model="computedReplace" dense label="Replace existing resources"></v-switch>
  </div>
</template>

<script>
import { read, writeFileXLSX } from "xlsx";
import { parseGenerators, generatorsTemplate } from "@/mixins/xlsx-utils";

export default {
  name: "ImportSpreadsheet",
  components: {},
  mixins: [],
  props: {
    value: { type: Array, required: false, default: () => [] },
    numYears: {
      type: Number,
      required: false,
      default: 1,
    },
    startYear: {
      type: Number,
      required: true,
    },
    replace: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return { file: null, error: null };
  },
  computed: {
    computedFile: {
      get() {
        return this.file;
      },
      async set(file) {
        this.file = file;
        if (file) {
          const data = await file.arrayBuffer();
          const workbook = read(data);
          try {
            const items = parseGenerators(workbook, {
              numYears: this.numYears,
              startYear: this.startYear,
            });
            this.$emit("input", items);
          } catch (error) {
            this.error = error;
          }
        }
      },
    },
    computedReplace: {
      get() {
        return this.replace;
      },
      set(v) {
        this.$emit("update:replace", v);
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    downloadTemplate() {
      const workbook = generatorsTemplate({
        numYears: this.numYears,
        startYear: this.startYear,
      });
      writeFileXLSX(workbook, "generators_template.xlsx");
    },
  },
};
</script>

<style></style>
